module.exports = __webpack_public_path__ + "static/media/business.7108afa3.webp";